import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Icon } from 'components/shared/Icon/Icon'
import { LockMessage } from 'components/shared/LockMessage/LockMessage'
import { Tooltip } from './common/Tooltip/Tooltip'

import { useButton } from './hooks'
import { ICON_SIZES, LOCK_ICON_SIZES } from './model'

import { LockIcon } from 'components/shared/Icon/model'

import styles from './Button.module.scss'

export const Button = ({
  ariaLabel,
  className = undefined,
  color,
  icon,
  label,
  message,
  size,
  type = 'button',
  variant,
  onClick,
  isContentReversed = false,
  isDisabled,
  isFullWidth,
  isLocked,
}) => {
  const { state, handlers } = useButton()

  const {
    arrowRef,
    arrowStyle,
    floating,
    floatingStyle,
    owner,
    reference,
    hasArrow,
    isToggled,
  } = state

  const {
    handleBlur,
    handleFocus,
    handleMouseEnter,
    handleMouseLeave,
    handleTouchEnd,
    handleTouchStart,
  } = handlers

  return (
    <>
      <button
        aria-label={ariaLabel}
        className={cx(styles.button, {
          [styles.size]: Boolean(size),
          [styles[size]]: Boolean(size),
          [styles.variant]: Boolean(variant),
          [styles[variant]]: Boolean(variant),
          [styles.color]: Boolean(color),
          [styles[color]]: Boolean(color),
          [styles.fullWidth]: isFullWidth,
          [className]: Boolean(className),
        })}
        type={type}
        onClick={onClick}
        disabled={isLocked || isDisabled}
        {...(R.or(isLocked, Boolean(message)) && {
          ref: reference,
          onBlur: handleBlur,
          onFocus: handleFocus,
          onPointerEnter: handleMouseEnter,
          onPointerLeave: handleMouseLeave,
          onTouchStart: handleTouchStart,
          onTouchEnd: handleTouchEnd,
        })}
      >
        <span
          className={cx(styles.content, {
            [styles.reversed]: isContentReversed,
          })}
        >
          {icon ? (
            <span
              className={cx(styles.assets, {
                [styles.nospacing]: !Boolean(label),
              })}
            >
              <Icon
                className={cx(styles.icon, {
                  [styles.locked]: isLocked,
                })}
                icon={icon}
                size={ICON_SIZES[size]}
              />
              {isLocked ? (
                <Icon
                  className={styles.lock}
                  icon={LockIcon}
                  size={LOCK_ICON_SIZES[size]}
                  style={{
                    top: `calc(50% - ${LOCK_ICON_SIZES[size] / 2}px)`,
                    left: isContentReversed
                      ? 'initial'
                      : `calc(50% - ${LOCK_ICON_SIZES[size] / 2}px)`,
                    right: isContentReversed
                      ? `calc(50% - ${LOCK_ICON_SIZES[size] / 2}px)`
                      : 'initial',
                  }}
                />
              ) : null}
            </span>
          ) : null}
          {label ? (
            <span
              className={cx(styles.label, {
                [styles.nospacing]: !Boolean(icon),
              })}
            >
              {label}
            </span>
          ) : null}
        </span>
      </button>
      {Boolean(message) ? (
        <Tooltip
          {...{
            arrowRef,
            arrowStyle,
            floating,
            floatingStyle,
            message,
            hasArrow,
            isDisabled,
            isToggled,
          }}
        />
      ) : null}
      {isLocked ? (
        <LockMessage
          {...{
            arrowRef,
            arrowStyle,
            floating,
            floatingStyle,
            owner,
            hasArrow,
            isToggled,
          }}
        />
      ) : null}
    </>
  )
}
